<div
  class="widget-wrapper"
  [class.open]="!widgetCollapsed"
  [@openCloseWidget]="widgetCollapsed ? 'hide' : 'show'"
>
  <div
    class="widget-header"
    [ngStyle]="{ zIndex: headerOverlay ? 1 : 0 }"
    [@openCloseWidgetHeader]="widgetCollapsed ? 'hide' : 'show'"
    (click)="toggleWidget()"
  >
    <ng-content select=".widget-header"></ng-content>
    <h4 *ngIf="title">{{ title | translate }}</h4>
  </div>
  <div
    class="container"
    [ngStyle]="{ zIndex: headerOverlay ? 0 : 1 }"
    [class.highlightMode]="highlight.length"
    [@openCloseWidgetContent]="widgetCollapsed ? 'hide' : 'show'"
  >
    <ng-content></ng-content>
  </div>
</div>
